/**
 * Loading spinner component
 * @param {Object} props - Component props
 * @param {string} props.size - Spinner size: 'sm' | 'md' | 'lg'
 * @param {string} props.className - Additional CSS classes
 */
const Spinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={`spinner ${sizeClasses[size]} ${className}`}></div>
  );
};

export default Spinner;
